var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgSuccess = function SvgSuccess(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "1em",
    height: "1em",
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3 24C3 12.402 12.402 3 24 3s21 9.402 21 21-9.402 21-21 21S3 35.598 3 24Zm31.06-4.94a1.5 1.5 0 0 0-2.12-2.12L21.75 27.128l-4.94-4.94a1.5 1.5 0 0 0-2.12 2.122l6 6a1.5 1.5 0 0 0 2.12 0l11.25-11.25Z",
    fill: "#38A169"
  })));
};
export default SvgSuccess;